import React from 'react';

/* eslint-disable max-len */
const SearchIcon: React.FC = () => {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path fillRule="evenodd" clipRule="evenodd" d="M16.75 9.99805C16.75 13.1737 14.1756 15.748 11 15.748C7.82436 15.748 5.25 13.1737 5.25 9.99805C5.25 6.82241 7.82436 4.24805 11 4.24805C14.1756 4.24805 16.75 6.82241 16.75 9.99805ZM15.6059 16.54C14.3036 17.4585 12.7148 17.998 11 17.998C6.58172 17.998 3 14.4163 3 9.99805C3 5.57977 6.58172 1.99805 11 1.99805C15.4183 1.99805 19 5.57977 19 9.99805C19 11.9146 18.3261 13.6737 17.2022 15.0514C17.2675 15.0937 17.3293 15.1434 17.3865 15.2006L21.7955 19.6096C22.2348 20.0489 22.2348 20.7613 21.7955 21.2006C21.3562 21.6399 20.6438 21.6399 20.2045 21.2006L15.7955 16.7916C15.7189 16.715 15.6557 16.6302 15.6059 16.54Z"/>
		</svg>
	);
}

export default SearchIcon;
